import { createBrowserRouter } from "react-router-dom";
import Abouts from "../components/About/Abouts";
import Blog from "../components/Blog/Blog";
import Homes from "../components/Home/Homes";
import Main from "../components/Layout/Main";
import Resumes from "../components/Resume/Resumes";
import Skills from "../components/Skill/Skills";
import Login from "../components/Login/Login";

import Error from "../components/Error/Error";
import Resource from "../components/Resource/Resource";






const router = createBrowserRouter([
             {
               path: '/',
               element: <Main></Main>,
               errorElement:<Error></Error>,
               children:[
                {
                    path:'/',
                    element:<Homes/>,
                    
                },
                {
                    path:'/resumes',
                    element: <Resumes/>

                },
                {
                    path:'/skills',
                    element:<Skills/>
                },
                {
                    path:'/blog',
                    element:<Blog/>
                },
                {
                    path:'/about',
                    element:<Abouts/>
                },
                {
                    path:'/login',
                    element:<Login/>
                },
                {
                    path:'/error',
                    element:<Error/>
                },
                {
                    path:'/resource',
                    element:<Resource/>
                }
               
                

               ]
             }
])

export default router;